import storage from '@/fetch/storage'

export const DEFAULT_LOGIN_PATH = '/yssz/login'
export const LAST_TENANT_KEY = 'lastTenantKey'

export function getTenantKeyFromPath(path = '') {
  const match = path.match(/^\/t\/([^/]+)(?:\/|$)/)
  return match ? decodeURIComponent(match[1]) : ''
}

export function stripTenantPrefix(path = '') {
  const tenantKey = getTenantKeyFromPath(path)
  if (!tenantKey) return path
  const stripped = path.replace(/^\/t\/[^/]+/, '')
  return stripped || '/'
}

export function saveTenantKey(tenantKey) {
  if (tenantKey) {
    storage.set(LAST_TENANT_KEY, tenantKey)
  }
}

export function getStoredTenantKey() {
  return storage.get(LAST_TENANT_KEY) || ''
}

export function getTenantLoginPath(route) {
  const tenantKey = getTenantKeyFromPath(route && route.path) || getStoredTenantKey()
  return tenantKey ? `/t/${tenantKey}/login` : DEFAULT_LOGIN_PATH
}

export function syncTenantKeyFromRoute(route) {
  const tenantKey = getTenantKeyFromPath(route && route.path)
  saveTenantKey(tenantKey)
  return tenantKey
}
